export default __webpack_public_path__ + "static/media/chatton1.1a78caea.jpg";